import { produce } from 'immer';
import { createReducer } from 'typesafe-actions';

import { getPricingControlsAction } from './actions';
import type { PricingControlsAction, PricingControlsState } from './types';

export const initialPricingControlsState: PricingControlsState = {
  rows: [],
};

export const pricingControlsReducer = createReducer<
  PricingControlsState,
  PricingControlsAction
>(initialPricingControlsState).handleAction(
  getPricingControlsAction.success,
  (state, { payload }) =>
    produce(state, (draftState) => {
      draftState.rows = payload;
    })
);
